// extracted by mini-css-extract-plugin
export default {"button":"MoreButton_button__N2x6P","icon":"MoreButton_icon__dcMYe"};